module.exports = __webpack_public_path__ + "img/include.f66d15ef.svg";